import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { ScrollProvider } from './context/ScrollContext';
import Header from './components/EntToEndUI/Header/Header';
import Home from './pages/Home/Home';
// import Contacts from './pages/Contacts';
import Price from './pages/Price';
import Contacts from './pages/Contacts/Contacts';
import Lasers from './pages/Services/Lasers/Lasers';
import SpeedBuildings from './pages/Services/SpeedBuildings/SpeedBuildings';
import CallButton from './components/Buttons/CallButton/CallButton';
import Footer from './components/EntToEndUI/Footer/Footer';
import BackgroundNoise from './components/EntToEndUI/BackgroundNoise/BackgroundNoise';
import Metall from './pages/Services/Metall/Metall';
import Installation from './pages/Services/Installation/Installation';
import './App.css';

function App() {
  const location = useLocation();

  // Прокрутка наверх при изменении маршрута
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="App">
      <div className="noise-container">
        <BackgroundNoise />
      </div>
      <ScrollProvider>
        <div className="content">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              {/* <Route path="/contacts" element={<Contacts />} /> */}
              <Route path="/price" element={<Price />} />
              <Route path="/Contacts" element={<Contacts />} />
              <Route path="/services/lasers" element={<Lasers />} />
              <Route path="/services/speedbuildings" element={<SpeedBuildings />} />
              <Route path="/services/metall" element={<Metall />} />
              <Route path="/services/installation" element={<Installation />} />
            </Routes>
          </main>
          <Footer />
          <CallButton />
        </div>
      </ScrollProvider>
    </div>
  );
}

export default App;
